import axios from 'axios'

import { type CoreStoreDomainStatus } from '@flecto/types'

/**
 * Add domain record to Vercel flecto-store project, through a local proxy.
 *
 * @endpoint POST /api/stores/domains/add
 * @scope saas (local proxy)
 */
export async function addStoreCustomDomain(
  domain: string
): Promise<CoreStoreDomainStatus> {
  return await axios.post('/api/stores/domains/add', { domain })
}
